// Vue Components Index
// This file exports all Vue components for easy importing

import HelloWorld from './HelloWorld.js'

export {
    HelloWorld,
}

// Component registry for global registration
export const components = {
    HelloWorld
} 